import Isotope from 'isotope-layout/dist/isotope.pkgd.min';
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd.min';
import createEvent from '@/scripts/utils/create-event';

class GridFilters {
  constructor(options) {
    this.el = options.el;
    this.grid = null;
    this.gridContent = this.el.querySelector(options.filteredContent);
    this.gridContentItem = options.filterContentItem;
    this.filtersContainerSelector = options.filtersContainer;
    this.filtersContainer = this.el.querySelector(this.filtersContainerSelector);
    this.filters = this.el.querySelectorAll(options.filter);
    this.buttonOpenFilters = this.el.querySelector(options.buttonOpenFilters);
    this.buttonCloseFilters = this.el.querySelector(options.buttonCloseFilters);
    this.buttonClearFilters = this.el.querySelector(options.buttonClearFilters);
    this.loadButton = this.el.querySelector(options.loadButton);
    this.loadingStage = 0;
  }

  isotopGridInit(el) {
    const grid = new Isotope(el, {
      itemSelector: this.gridContentItem,
      percentPosition: true,
      isJQueryFiltering: false,
    });
    imagesLoaded(el).on('progress', () => {
      grid.layout();
    });
    return grid;
  }

  toggleFilters(btn) {
    if (btn.classList.contains('opened')) {
      btn.classList.remove('opened');
    } else {
      btn.classList.add('opened');
    }
    this.filtersContainer.classList.toggle('opened');
  }

  buildFilterTagsArr() {
    const arr = [];
    const selected = this.filtersContainer.querySelectorAll('.selected');

    Array.from(selected).forEach((selectEl) => {
      const filterTag = selectEl.getAttribute('data-filter-tag');
      arr.push(filterTag);
    });

    return arr;
  }

  filtration() {
    const filterTags = this.buildFilterTagsArr();
    const filterTagsLength = filterTags.length;
    if (!filterTagsLength) {
      this.buttonClearFilters.classList.remove('is-show');
    }

    this.grid.arrange({
      filter(itemElem) {
        if (filterTagsLength) {
          const classListArr = Array.from(itemElem.classList);
          const intersection = classListArr.filter(x => filterTags.includes(x));
          return !!intersection.length;
        }
        return true;
      },
    });
  }

  loadItems() {
    const { params } = this.loadButton.dataset;
    const { type, url, data } = JSON.parse(params);
    this.loadButton.classList.add('loading');
    $.ajax({
      type,
      url,
      data: {
        ...data,
        num: this.loadingStage++, // eslint-disable-line no-plusplus
      },
      success: (result) => {
        if (result) {
          this.grid.insert($(result));
          imagesLoaded(this.gridContent, () => {
            this.grid.layout();
            this.loadButton.classList.remove('loading');
            window.dispatchEvent(createEvent('resize'));
          });
        } else {
          this.loadButton.classList.add('is-disabled');
        }
      },
      error: () => {
        this.loadButton.classList.add('is-disabled');
      },
    });
  }

  init() {
    if (!this.el) return;
    const that = this;
    this.grid = that.isotopGridInit(this.gridContent);

    this.loadButton.addEventListener('click', this.loadItems.bind(this));
    this.buttonOpenFilters.addEventListener('click', function () {
      that.toggleFilters(this);
    });
    this.buttonCloseFilters.addEventListener('click', () => {
      that.toggleFilters(that.buttonOpenFilters);
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest(this.filtersContainerSelector) && this.filtersContainer.classList.contains('opened')) {
        that.toggleFilters(that.buttonOpenFilters);
      }
    });
    this.buttonClearFilters.addEventListener('click', () => {
      const selected = this.filtersContainer.querySelectorAll('.selected');
      Array.from(selected).forEach((selectEl) => {
        selectEl.classList.remove('selected');
        that.filtration();
      });
    });
    Array.from(this.filters).forEach((filter) => {
      filter.addEventListener('click', function () {
        if (this.classList.contains('selected')) {
          this.classList.remove('selected');
        } else {
          this.classList.add('selected');
          that.buttonClearFilters.classList.add('is-show');
        }
        that.filtration(this);
      });
    });
  }
}

export default function initGridWithFilters(options) {
  const defaults = {
    el: null,
    filteredContent: '[data-type="grid"]',
    filterContentItem: '[data-type="grid-item"]',
    filtersContainer: '[data-type="grid-filters"]',
    filter: '[data-type="filter"]',
    buttonOpenFilters: '[data-type="filters-button-open"]',
    buttonCloseFilters: '[data-type="filters-button-close"]',
    buttonClearFilters: '[data-type="filters-button-clear"]',
    loadButton: '[data-type="load-more"]',
  };
  const gridFilters = new GridFilters(Object.assign({}, defaults, options));
  gridFilters.init();
}



// WEBPACK FOOTER //
// ./scripts/blocks/filters.js